import './ThumbnailImage.scss';

export { default } from './ThumbnailImage';
